import {
  ADD_USER_FAILURE,
  ADD_USER_LOADING,
  ADD_USER_SUCCESS,
  DELETE_USER_FAILURE,
  DELETE_USER_LOADING,
  DELETE_USER_SUCCESS,
  FETCH_BUILDING_USERS_FAILURE,
  FETCH_BUILDING_USERS_LOADING,
  FETCH_BUILDING_USERS_SUCCESS,
  FETCH_BY_ID_USER_FAILURE,
  FETCH_BY_ID_USER_LOADING,
  FETCH_BY_ID_USER_SUCCESS,
  FETCH_MANAGERS_FAILURE,
  FETCH_MANAGERS_SUCCESS,
  FETCH_USERS_FAILURE,
  FETCH_USERS_LOADING,
  FETCH_USERS_SUCCESS,
  UPDATE_USER_FAILURE,
  UPDATE_USER_LOADING,
  UPDATE_USER_SUCCESS
} from '../Types/userTypes';
import api from '../config/api';
import { Decrypt } from './Crypto';

const API_URL = process.env.REACT_APP_API_URL;

export const getUsers = () => {
  return dispatch => {
    dispatch({
      type: FETCH_USERS_LOADING
    });
    api
      .get(`${API_URL}User/getAllUsers`)
      .then(response => {
        // const data = response.data.data;
        const data = Decrypt(response.data.data);
        dispatch(fetchUsersSuccess(data));
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch(fetchUsersError(errorMsg));
      });
  };
};

export const getUsersWithoutDispatch = () => {
  return api
    .get(`${API_URL}User/getUsers`)
    .then(response => {
      const data = response.data.data;
      return data;
    })
    .catch(error => {
      const errorMsg = error.message;
      return [];
    });
};

export const fetchUsersSuccess = (data, total) => {
  return {
    type: FETCH_USERS_SUCCESS,
    payload: data,
    total: total
  };
};

export const fetchUsersError = error => {
  return {
    type: FETCH_USERS_FAILURE,
    payload: error
  };
};

export const fetchUserSuccess = data => {
  return {
    type: FETCH_BY_ID_USER_SUCCESS,
    payload: data
  };
};

export const fetchUserError = error => {
  return {
    type: FETCH_BY_ID_USER_FAILURE,
    payload: error
  };
};

export const fetchUserLoading = () => {
  return {
    type: FETCH_BY_ID_USER_LOADING
  };
};

export const getAdminUsers = (params = {}, filter = {}) => {
  return dispatch => {
    dispatch({
      type: FETCH_USERS_LOADING
    });

    const query = new URLSearchParams();
    if (params.page) query.append('page', params.page);
    if (params.limit) query.append('limit', params.limit);
    if (Object.keys(filter).length > 0) {
      query.append('filter', encodeURIComponent(JSON.stringify(filter)));
    }
    const url = `${API_URL}User/?${query.toString()}`;

    return api
      .get(url)
      .then(response => {
        const { data, total } = response.data;
        const users = Decrypt(data);
        dispatch(fetchUsersSuccess(users, total));
        return users;
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_USERS_FAILURE,
          payload: errorMsg
        });
        throw error;
      });
  };
};

export const getUserByID = id => {
  return dispatch => {
    dispatch(fetchUserLoading);
    api
      .get(`${API_URL}User/search/${id}`)
      .then(response => {
        const data = response.data.data;
        dispatch(fetchUserSuccess(data));
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch(fetchUserError(errorMsg));
      });
  };
};

export const getManagers = () => {
  return dispatch => {
    dispatch({
      type: FETCH_USERS_LOADING
    });
    api
      .get(`${API_URL}User/getManagers`)
      .then(response => {
        const data = response.data.data;
        dispatch({
          type: FETCH_MANAGERS_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_MANAGERS_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const getUserBalance = async id => {
  const result = await api
    .get(`${API_URL}Balance/getUserBalance/${id}`)
    .then(response => {
      return response.data.data[0];
    })
    .catch(error => {
      const errorMsg = error.message;
      return errorMsg;
    });

  return result;
};

export const updateUser = (id, formData) => {
  return dispatch => {
    dispatch({
      type: UPDATE_USER_LOADING
    });
    api
      .put(`${API_URL}User/updateuserprofile/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: UPDATE_USER_SUCCESS,
          payload: data
        });
        dispatch(getUserByID(id));
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: UPDATE_USER_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const blockUser = (id, data) => {
  return dispatch => {
    dispatch({
      type: UPDATE_USER_LOADING
    });
    api
      .put(`${API_URL}User/block/${id}`, { data })
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: UPDATE_USER_SUCCESS,
          payload: data
        });
        dispatch(getUserByID(id));
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: UPDATE_USER_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const addUser = formData => {
  return dispatch => {
    dispatch({
      type: ADD_USER_LOADING
    });

    return api
      .post(`${API_URL}User/signup`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: ADD_USER_SUCCESS,
          payload: data
        });
        // return data;
        dispatch(getAdminUsers());
      })
      .catch(error => {
        const errorMsg = error.response.data.errors || error.message;
        // console.log('errorMsg', error.response.data.errors);
        dispatch({
          type: ADD_USER_FAILURE,
          payload: errorMsg
        });
        throw new Error(errorMsg);
      });
  };
};

export const removeUser = id => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({ type: DELETE_USER_LOADING });
      api
        .delete(`${API_URL}User/delete/${id}`)
        .then(() => {
          dispatch({
            type: DELETE_USER_SUCCESS,
            payload: id
          });
          resolve({ status: 200 });
        })
        .catch(error => {
          dispatch({
            type: DELETE_USER_FAILURE,
            payload: error.message
          });
          reject(error.message);
        });
    });
  };
};

export const updateUsersMass = data => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({ type: DELETE_USER_LOADING });
      api
        .post(`${API_URL}User/updateUsersMass`, data)
        .then(() => {
          dispatch(getAdminUsers());
          resolve({ status: 200 });
        })
        .catch(error => {
          reject(error.message);
        });
    });
  };
};

export const getBuildingUsers = (building, date) => {
  return dispatch => {
    dispatch({
      type: FETCH_BUILDING_USERS_LOADING
    });
    api
      .get(`${API_URL}availability/usersInBuilding/${building}/${date}`)
      .then(response => {
        const data = response.data.data;
        dispatch(fetchBuildingUsersSuccess(data));
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch(fetchBuildingUsersError(errorMsg));
      });
  };
};
export const fetchBuildingUsersSuccess = data => {
  return {
    type: FETCH_BUILDING_USERS_SUCCESS,
    payload: data
  };
};
export const fetchBuildingUsersError = error => {
  return {
    type: FETCH_BUILDING_USERS_FAILURE,
    payload: error
  };
};

export const UpdatePasswordUser = async (id, data) => {
  const result = await api
    .put(`${API_URL}User/updatemyprofile/${id}`, data)
    .then(response => {
      return response.data;
    })
    .catch(e => {
      const message = e.response && e.response.data && e.response.data.error;
      return message;
    });

  return result;
};
